// src/components/Unauthorized.js
import React from 'react';
import { Link } from 'react-router-dom';

const Unauthorized = () => {
    return (
        <div className="unauthorized-page">
            <h1>Unauthorized</h1>
            <p>You do not have permission to view this page.</p>
            <Link to="/">Return to Home</Link>
        </div>
    );
};

export default Unauthorized;
